import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const NOINDEX_PREFIXES = [
  '/pdf/',
  '/forms/',
  '/tracking/',
  '/review/',
  '/pay',
  '/estimates/',
  '/access/',
]

function shouldNoIndexPath(pathname: string): boolean {
  return NOINDEX_PREFIXES.some(
    (prefix) => pathname === prefix.replace(/\/$/, '') || pathname.startsWith(prefix)
  )
}

/**
 * Sets robots noindex on customer-portal token and payment routes.
 */
export function useNoIndex(): void {
  useEffect(() => {
    let meta = document.querySelector('meta[name="robots"]')
    if (!meta) {
      meta = document.createElement('meta')
      meta.setAttribute('name', 'robots')
      document.head.appendChild(meta)
    }
    meta.setAttribute('content', 'noindex, nofollow')
  }, [])
}

export function useCustomerPortalNoIndex(): void {
  const { pathname } = useLocation()
  const noindex = shouldNoIndexPath(pathname)

  useEffect(() => {
    if (!noindex) return
    let meta = document.querySelector('meta[name="robots"]')
    if (!meta) {
      meta = document.createElement('meta')
      meta.setAttribute('name', 'robots')
      document.head.appendChild(meta)
    }
    meta.setAttribute('content', 'noindex, nofollow')
  }, [noindex])
}
